import { Story, Knobs, Accents } from '../../DocTypes';

const multiCheckStoryKnobs: Knobs = {
  multiCheckAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
    delimiter: '\n  ',
  },
  multiCheckAlign: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'left', 'right'],
    delimiter: '\n  ',
  },
  multiCheckSize: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'normal', 'large'],
    delimiter: '\n  ',
  },
  multiCheckRounded: { default: '', editor: 'checkbox', delimiter: '\n  ' },
  multiCheckSuppressSelectAll: { default: '', editor: 'checkbox', delimiter: '\n  ' },
  multiCheckSelectAllPosition: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'bottom', 'top'],
    delimiter: '\n  ',
  },
  multiCheckSelectAllLabel: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
};
export const multiCheckWithDefaultsStory: Story = {
  title: 'Multi-check with defaults',
  description: 'List with items that can be checked with Sarah Young checked by default',
  coreComponent: {
    html: `<tag-list
    primary-field='name'
    multi-check{{multiCheckAccent}}{{multiCheckAlign}}{{multiCheckSize}}{{multiCheckRounded}}{{multiCheckSuppressSelectAll}}{{multiCheckSelectAllPosition}}{{multiCheckSelectAllLabel}}>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      {
        name: 'Jordan Norry'
      },
      {
        name: 'Sarah Young'
      },
      {
        name: 'Susan Warmly'
      }
    ]);
    tagList.setCheckedItems([{name: 'Sarah Young'}]);
  });
  `,
    knobs: multiCheckStoryKnobs,
  },

  reactWrapper: {
    jsx: `<Example />`,
    knobs: multiCheckStoryKnobs,
    parentJSX: `Example = () => {
      const [checkedItems, setCheckedItems] = React.useState([{ name: 'Sarah Young' }])
      return (
        <div>
          <TagList
            primaryField='name'
            data={[
              {
                name: 'Jordan Norry'
              },
              {
                name: 'Sarah Young'
              },
              {
                name: 'Susan Warmly'
              }
            ]}
            multiCheck{{multiCheckAccent}}{{multiCheckAlign}}{{multiCheckSize}}{{multiCheckRounded}}{{multiCheckSuppressSelectAll}}{{multiCheckSelectAllPosition}}{{multiCheckSelectAllLabel}}
            checkedItems={checkedItems}
            onListItemsChecked={e => setCheckedItems(e.detail.checkedItems.slice(0))}
          />

          <p>{checkedItems.length} item(s) selected</p>
        </div>
      )
    }`,
  },
};
